import React from 'react'
import clsx from 'clsx'
import style from './style.module.scss'

type NoResultProps = {
    title?: string
    hasSubtitle?: boolean
    className?: string
}

export const NoResult: React.FC<NoResultProps> = ({
    title = 'Aucun résultat trouvé',
    hasSubtitle = true,
    className,
}) => (
    <div className={clsx(style.component, className)}>
        <div className={style.title}>{title}</div>

        {hasSubtitle && (
            <div className={style.subtitle}>
                Désolé, aucun résultat n'a été trouvé pour votre recherche. Veuillez vérifier
                l'orthographe et les critères de recherche, ou essayez une autre requête.
            </div>
        )}
    </div>
)
